let resumeData = {
    "imagebaseurl":"https://kequach.github.io/",
    "name": `Keven Quach`,
    "role": "Full-stack Software Engineer @ Bosch",
    "linkedinId":"keven-quach-9907b7122",
    "skypeid": "Your skypeid",
    "roleDescription": `Backend focused | Cloud-native infrastructure | DevOps | Customer-facing engineering`,
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/keven%F0%9F%96%B1%EF%B8%8F-quach-9907b7122/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"http://github.com/kequach",
          "className":"fa fa-github"
        }
      ],
    "aboutme":`I am a full-stack software engineer who enjoys working between backend development, team-side infrastructure topics, and customer enablement. My work combines software development, customer workshops, demos, technical documentation, and hands-on troubleshooting for users.

At Bosch Connected Industry, I contribute to Nexeed Device Portal, a cloud-native device management platform used by 50+ global customers and more than 500,000 connected devices. My day-to-day work spans Java/Spring Boot development, Kubernetes-related service configuration, CI/CD and GitOps workflows, production troubleshooting, monitoring, technical documentation, and customer-facing support.

I like roles where technical work and communication meet. I have helped run multi-day customer workshops, explained API and infrastructure-adjacent concepts to different audiences, supported users with practical use cases and device troubleshooting, and shared knowledge around Kubernetes, Helm, ArgoCD, Vault, and pipeline concepts inside the team.

My background also includes research, teaching, mentoring, and consulting experience. During my Master's thesis at Utrecht University, I analyzed 1,500+ GitHub repositories as part of the SWORDS@UU open science project; the work was featured by Utrecht University, archived on Zenodo, and presented at deRSE23. I am especially interested in Customer Success Engineering, Solutions Engineering, Sales Engineering, and DevOps-oriented Software Engineering roles.
    `,
    "address":"Frankfurt, Germany",
    "website":"[kequach.github.io](https://kequach.github.io/)",
    "education":[
      {
        "UniversityName":"Utrecht University (NL)",
        "specialization":"Business Informatics - Applied Data Science Profile",
        "MonthOfJoining":"Sep",
        "YearOfJoining":"2020",
        "MonthOfPassing":"Oct",
        "YearOfPassing":"2022",
        "Achievements":`Grade: 8.2 / 10 (cum laude, top distinction; 10 = best)
• Master thesis grade 8.5 / 10 | Mapping Research Software Landscapes through Exploratory Studies of GitHub Data
• Developed a data collection and labelling pipeline and analyzed 1,500+ GitHub repositories as part of SWORDS@UU`
      },
      {
        "UniversityName":"Otto-Friedrich-University Bamberg (GER)",
        "specialization":"Information Systems",
        "MonthOfJoining":"Oct",
        "YearOfJoining":"2015",
        "MonthOfPassing":"Oct",
        "YearOfPassing":"2019",
        "Achievements":`Final grade: 1.4 (very good, top 2 of cohort)
• Semester abroad at Skövde University (SWE), Aug 2018 - Jan 2019 | Grade average A (excellent)
• Bachelor thesis grade 1.3 (very good) | How Semantic Text Features in Project Descriptions Predict Funding Success: An Exploratory Study from a Reward-Based Crowdfunding Platform`
      }
    ],
    "work":[
      {
        "CompanyName":"Bosch Connected Industry",
        "Location":"Immenstaad am Bodensee / Remote",
        "specialization":"Software Engineer",
        "MonthOfJoining":"Nov",
        "YearOfJoining":"2022",
        "MonthOfLeaving":"Present",
        "YearOfLeaving":"",
        "Achievements":`- Software engineer for [Nexeed Device Portal](https://www.bosch-connected-industry.com/de/en/portfolio/nexeed-automation/device-management), a cloud-native multi-tenant SaaS platform for 50+ global customers and 500,000+ connected devices, including dedicated on-premises service environments for internal Bosch customers; focusing on customer workshops, infrastructure enablement and agile backend development
  - Designed and led a multi-day technical onboarding workshop for a strategic customer; served as technical contact throughout onboarding and advised users on practical use cases, API usage, configuration and device troubleshooting
  - Presented technical demos, product capabilities and infrastructure topics to customers, external stakeholders and internal teams, including feature demos and explanations of new pipeline structures
  - Led the platform's first dedicated on-premises service deployment for internal Bosch customers who could not use the standard cloud environment; coordinated infrastructure and monitoring stakeholders and documented a repeatable runbook
  - Team-side technical point of contact for infrastructure topics, collaborating with dedicated platform/system teams on Helm, ArgoCD, HashiCorp Vault, mTLS device identity and Trivy scans; built and maintained CI/CD pipelines
  - Full-stack development with primary focus on backend and infrastructure using Java and Spring Boot; created audience-specific technical documentation for developers, operations teams and end users
  - Took over and documented a previously undocumented billing process, automated recurring steps and reduced monthly effort from about 2 hours to under 15 minutes, improving the reliability and timeliness of customer-facing billing data; developed VBA automation reducing effort of a quarterly process from 3 days to under 2 minutes
          `
      },
      {
        "CompanyName":"Utrecht University",
        "Location":"Utrecht",
        "specialization":"Research & Teaching Assistant",
        "MonthOfJoining":"Nov",
        "YearOfJoining":"2020",
        "MonthOfLeaving":"Oct",
        "YearOfLeaving":"2022",
        "Achievements":`• Conducted Master thesis as part of [SWORDS@UU](https://github.com/UtrechtUniversity/SWORDS-UU), independently developing a data collection and labelling pipeline and analyzing 1,500+ GitHub repositories using Python, classification models, and statistical analysis
  ◦ Findings featured in Utrecht University's article [How FAIR is the software landscape of Utrecht University?](https://www.uu.nl/en/news/how-fair-is-the-software-landscape-of-utrecht-university), archived on Zenodo, and presented at [deRSE23](https://zenodo.org/records/8150215)
  ◦ Contributed recommendations for FAIR research software practices
• Supervised tutorials and assignments for the course “Concurrency”
        `
      },
      {
        "CompanyName":"Procter & Gamble",
        "Location":"Schwalbach",
        "specialization":"IT Intern",
        "MonthOfJoining":"Jul",
        "YearOfJoining":"2021",
        "MonthOfLeaving":"Sep",
        "YearOfLeaving":"2021",
        "Achievements":`• Gathered requirements and led monitoring development for an IIoT platform
  ◦ Implemented Prometheus metrics in Python
  ◦ Created Grafana dashboards for ML model monitoring
        `
      },
      {
        "CompanyName":"STAT-UP Statistical Consulting & Data Science GmbH",
        "Location":"Munich",
        "specialization":"Data Science Intern",
        "MonthOfJoining":"Apr",
        "YearOfJoining":"2020",
        "MonthOfLeaving":"Jul",
        "YearOfLeaving":"2020",
        "Achievements":`• Supported a project analyzing contamination levels in industrial cotton machines using edge computing hardware
• Developed a Shiny app for component configuration
• Designed internal training on web development
        `
      },
      {
        "CompanyName":"Robert Bosch GmbH",
        "Location":"Tokyo",
        "specialization":"IoT Inhouse Consulting Intern",
        "MonthOfJoining":"Nov",
        "YearOfJoining":"2019",
        "MonthOfLeaving":"Mar",
        "YearOfLeaving":"2020",
        "Achievements":`• Supported an IoT project with a Japanese automotive manufacturer
  ◦ Set up cloud infrastructure for an IoT customer project and developed an Angular web UI for a customer call center
  ◦ Connected cloud infrastructure to backend systems through VPN setup
• Conducted weekly Python training for an IoT cross-departmental team
• Organized a location-wide IoT Hackathon event
         `
      },
      {
        "CompanyName":"Robert Bosch GmbH",
        "Location":"Bamberg",
        "specialization":"Working Student Web Application Development",
        "MonthOfJoining":"Sep",
        "YearOfJoining":"2018",
        "MonthOfLeaving":"Oct",
        "YearOfLeaving":"2019",
        "Achievements":`• Contributed to a project team digitalizing logistics processes using Angular and PHP
  ◦ Continued development of live systems and implementation of new solutions
  ◦ Provided independent second-level support for three ongoing projects
  ◦ Managed ETL processes with Talend
        `
      },
      {
        "CompanyName":"Cogita! e.V.",
        "Location":"Bamberg",
        "specialization":"Junior Consultant & Board Member External Relations",
        "MonthOfJoining":"May",
        "YearOfJoining":"2017",
        "MonthOfLeaving":"Jul",
        "YearOfLeaving":"2019",
        "Achievements":`• Represented a student consulting organization as Board Member for External Relations, managing corporate partners, acquiring new business partners and workshops, and coordinating client inquiries
• Led training and enablement activities for acquisition and workshops departments, supporting a team of 20 members
• Managed a case study contest and workshop series with 100+ participants and €5,000 in revenue`
      },
      {
        "CompanyName":"Otto-Friedrich-University Bamberg",
        "Location":"Bamberg",
        "specialization":"Volunteer Make IT Mentor",
        "MonthOfJoining":"Oct",
        "YearOfJoining":"2018",
        "MonthOfLeaving":"Jul",
        "YearOfLeaving":"2019",
        "Achievements":`• Mentored two school students on university life in IT, including financial matters, curriculum, preparation, career perspectives, and effective study methods`
      },
      {
        "CompanyName":"Otto-Friedrich-University",
        "Location":"Bamberg",
        "specialization":"Teaching Assistant",
        "MonthOfJoining":"Apr",
        "YearOfJoining":"2017",
        "MonthOfLeaving":"Jul",
        "YearOfLeaving":"2019",
        "Achievements":`• Supervised tutorials and assignments for the courses “Introduction to Computer Architecture and Operating Systems”, “Introduction to Algorithms, Programming and Software”, “Java Programming”, and “Advanced Java Programming” over four semesters`
      },
      {
        "CompanyName":"PricewaterhouseCoopers GmbH",
        "Location":"Frankfurt",
        "specialization":"Technology Consulting Intern",
        "MonthOfJoining":"Jan",
        "YearOfJoining":"2018",
        "MonthOfLeaving":"Mar",
        "YearOfLeaving":"2018",
        "Achievements":`• Supported a large-scale data warehouse project for a banking client focusing on data quality and governance
    ◦ Oversaw software development processes
    ◦ Coordinated between the client's business units and development teams
    ◦ Analyzed business data models, transformation logic, and ETL processes
        `
      }
    ],
    "skills":[
      {
        "skillname":"Customer-facing engineering: technical workshops, onboarding, demos, stakeholder communication, use-case translation, API guidance, configuration support, device troubleshooting, and customer documentation"
      },
      {
        "skillname":"Backend & full-stack: Java, Spring Boot, REST/API integration, Liquibase, Playwright, Angular, TypeScript, JavaScript/HTML/CSS"
      },
      {
        "skillname":"DevOps & team-side infrastructure configuration: Kubernetes service configuration, Helm values for central templates, ArgoCD applications, Docker, Maven, Azure DevOps, Azure Pipelines, CI/CD, on-premises deployment runbooks"
      },
      {
        "skillname":"Cloud & security: Azure, Terraform, HashiCorp Vault, mTLS, OIDC/JWT, Trivy"
      },
      {
        "skillname":"Monitoring & operations: Elasticsearch, Kibana, Redis, Prometheus, Grafana, production troubleshooting, root-cause analysis, runbooks"
      },
      {
        "skillname":"Automation & data: Python, PowerShell, SQL (Azure SQL, Oracle), VBA, R, process automation, data collection pipelines, statistical analysis"
      },
      {
        "skillname":"Documentation & enablement: Arc42, AsciiDoc, Antora, developer documentation, operations documentation, end-user documentation, Git, GitHub Copilot, Cursor"
      },
      {
        "skillname":"Certifications: CKAD, Microsoft Certified Azure Administrator Associate (AZ-104), Microsoft Azure Fundamentals (AZ-900), HashiCorp Certified Terraform Associate (004), iSAQB Certified Professional for Software Architecture - Foundation Level (CPSA-F)"
      },
    ],
    "interests":[
      {
        "interest":`Esports - competitive Super Smash Bros. Melee player since 2008
  ◦ [Top 14 in Germany 2022](https://www.ssbwiki.com/German_Power_Rankings#2022_2)
  ◦ 1st/17 at [Z-Drop 2, Augsburg](https://www.start.gg/tournament/z-drop-2-1/event/melee-singles/standings)
  ◦ 5th/42 at [TGM Esports Unlimited #2, Mainz](https://www.start.gg/tournament/tgm-esports-unlimited-2/event/melee-singles/standings)
  ◦ 7th/59 at [Battlegateway #30, Tokyo](https://www.start.gg/tournament/battlegateway-30/event/dx-melee-singles-1-vs-1/standings)
  ◦ 9th/69 at [Reimeisai- #0, Tokyo](https://www.start.gg/tournament/reimeisai-0/event/ssbm-1vs1/standings)
  ◦ 13th/111 at [Awakening II, Munich](https://www.start.gg/tournament/awakening-ii/event/melee-singles/standings)
  ◦ 17th/118 at [RAID, London](https://www.start.gg/tournament/raid/event/melee-singles/standings)
  ◦ 33rd/203 at [Dreamhack Rotterdam Smash Championship 2022](https://www.start.gg/tournament/dreamhack-rotterdam-smash-championship-2022/event/melee-singles/standings)
  ◦ 49th/226 at [Sapf, Hannover](https://www.start.gg/tournament/sapf/event/melee-singles/standings)
        
        `
      },
      {
        "interest":`Table tennis 
  ◦ Played in multiple clubs
  ◦ Currently playing for TV Preungesheim 1880 / HeTTV`
      },
      {
        "interest":"Bouldering"
      },
      {
        "interest":"Video games - mostly roguelikes and JRPGs"
      },
      {
        "interest":"Cooking"
      },
      {
        "interest":"Juggling"
      }
    ],
    "portfolio":[
      {
        "name":"SWORDS",
        "description":`Scan and revieW of Open Research Data and Software (SWORDS) project. For my Master's thesis, I developed a data collection and labelling pipeline and analyzed 1,500+ GitHub repositories to map research software and FAIR practices at Utrecht University. The work was featured in [Utrecht University's article](https://www.uu.nl/en/news/how-fair-is-the-software-landscape-of-utrecht-university), presented at [deRSE23](https://zenodo.org/records/8150215), and helped seed an [awesome open source list from Utrecht University](https://github.com/UtrechtUniversity/awesome-utrecht-university).`,
        "logo":"images/swordslogo.png",
        "github":"https://github.com/UtrechtUniversity/SWORDS-UU"
      },
      {
        "name":"Cashback Tracker",
        "description":`A local-first Android app for tracking cashback and "try for free" promotions. Built with Kotlin, Jetpack Compose, Material 3, Room, DataStore, Android Keystore-backed encryption, and jsoup. It includes user-triggered URL analysis, CSV import/export, duplicate-use warnings, release automation, documentation, and focused parser/export tests.`,
        "logo":"images/cashbacktracker.svg",
        "github":"https://github.com/kequach/cashbacktracker"
      },
      {
        "name":"Uniqlo sales alerter",
        "description":`A self-hosted, open source Uniqlo sale alert tool that watches the sale catalogue, filters by size, discount, stock status, and country, then sends matching deals by email or Telegram. It runs in Docker, includes a browser-based settings UI, and supports 22 countries across Europe, Asia, and North America.`,
        "logo":"images/uniqlo.png",
        "github":"https://github.com/kequach/uniqlo-sales-alerter"
      },
      {
        "name":"start.gg-event-adder",
        "description":`A Discord bot that fetches real tournament data from the start.gg API and creates scheduled events in Discord servers. It reflects the same kind of practical automation I like in engineering work: take a repeated coordination task, connect the APIs, and make the workflow easier for users.`,
        "logo":"images/startgglogo.png",
        "github":"https://github.com/kequach/start.gg-event-adder"
      },
      {
        "name":"Doctor collector",
        "description":`Doctor Collector is a local Python app for finding therapist contact details on therapie.de, reviewing the collected results, and optionally sending an initial consultation request (Erstgespräch) by email.`,
        "logo":"images/logo-doctor-collector.png",
        "github":"https://github.com/kequach/Doctor-collector"
      }
    ],
    "testimonials":[
      {
        "description":"Keven delivered an outstanding, detailed, and well-structured introduction to the ctrlX CORE X3 and Device Portal. His clear explanations, patience, and practical guidance gave the team confidence in working with the system.",
        "name":"Customer workshop feedback"
      },
      {
        "description":"Leadership feedback has described my work as analytical, constructive, and structured, especially around documenting infrastructure-adjacent topics and repeatable processes.",
        "name":"Technical leadership feedback"
      },
      {
        "description":"Peer feedback has highlighted reliability when taking over topics, pragmatic problem solving, and proactive knowledge sharing.",
        "name":"Peer feedback"
      },
      {
        "description":"Team feedback has highlighted my willingness to learn new technologies and contribute around Kubernetes-related team configuration, build topics, pipelines, testing, and operations work.",
        "name":"Team feedback"
      }
    ]
  }
  
  export default resumeData
